(() => {
  const boot = () => document.querySelectorAll('.pc-date-form').forEach(form => {
    if (form.dataset.calendarReady) return;
    form.dataset.calendarReady = 'true';
    const start = form.querySelector('[name="arrival"]');
    const end = form.querySelector('[name="departure"]');
    const arrivalTime = form.querySelector('[name="arrival_time"]');
    const departureTime = form.querySelector('[name="departure_time"]');
    const airportUrl = form.action;
    const today = new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Rome', year:'numeric', month:'2-digit', day:'2-digit'}).format(new Date());
    const locale = document.documentElement.lang || 'it';
    const parse = value => new Date(value + 'T12:00:00');
    const iso = date => [date.getFullYear(), String(date.getMonth()+1).padStart(2,'0'), String(date.getDate()).padStart(2,'0')].join('-');
    const dateLabel = value => value ? new Intl.DateTimeFormat(locale, {day:'numeric', month:'short', year:'numeric'}).format(parse(value)) : form.dataset.chooseDate;
    const calendar = form.querySelector('.pc-range-calendar');
    const startButton = form.querySelector('[data-calendar-start]');
    const endButton = form.querySelector('[data-calendar-end]');
    const grid = calendar.querySelector('[data-calendar-days]');
    const title = calendar.querySelector('[data-calendar-title]');
    const monthTitle = calendar.querySelector('[data-calendar-month]');
    const status = calendar.querySelector('[data-calendar-status]');
    const prev = calendar.querySelector('[data-calendar-prev]');
    const next = calendar.querySelector('[data-calendar-next]');
    let phase = 'arrival';
    let month = parse(today);
    let opener;
    let originalRange;
    const refreshLabels = () => {
      startButton.textContent = dateLabel(start.value);
      endButton.textContent = dateLabel(end.value);
      startButton.classList.toggle('has-value', Boolean(start.value));
      endButton.classList.toggle('has-value', Boolean(end.value));
    };
    const selectDate = value => {
      if (phase === 'arrival' || value < start.value) {
        start.value = value;
        end.value = '';
        phase = 'departure';
        refreshLabels();
        render(value);
      } else {
        end.value = value;
        refreshLabels();
        calendar.close('selected');
        endButton.focus();
      }
    };
    const render = focusDate => {
      title.textContent = phase === 'arrival' ? calendar.dataset.arrivalTitle : calendar.dataset.departureTitle;
      monthTitle.textContent = new Intl.DateTimeFormat(locale, {month:'long', year:'numeric'}).format(month);
      status.textContent = start.value ? dateLabel(start.value) + ' → ' + dateLabel(end.value) : calendar.dataset.hint;
      prev.disabled = month.getFullYear() === parse(today).getFullYear() && month.getMonth() === parse(today).getMonth();
      const first = new Date(month.getFullYear(), month.getMonth(), 1, 12);
      const offset = (first.getDay()+6)%7;
      const count = new Date(month.getFullYear(), month.getMonth()+1, 0).getDate();
      const fragment = document.createDocumentFragment();
      for (let i=0; i<offset; i++) fragment.append(document.createElement('span'));
      for (let day=1; day<=count; day++) {
        const date = new Date(month.getFullYear(), month.getMonth(), day, 12);
        const value = iso(date);
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.date = value;
        button.textContent = String(day);
        button.disabled = value < today;
        button.setAttribute('aria-label', new Intl.DateTimeFormat(locale, {weekday:'long',day:'numeric',month:'long',year:'numeric'}).format(date));
        button.setAttribute('aria-pressed', String(value === start.value || value === end.value));
        if (value === today) button.setAttribute('aria-current', 'date');
        if (value === start.value || value === end.value) button.classList.add('is-selected');
        if (start.value && end.value && value > start.value && value < end.value) button.classList.add('in-range');
        fragment.append(button);
      }
      grid.replaceChildren(fragment);
      const target = grid.querySelector('[data-date="'+(focusDate || (phase === 'departure' ? start.value : today))+'"]:not(:disabled)') || grid.querySelector('button:not(:disabled)');
      grid.querySelectorAll('button').forEach(button => button.tabIndex = button === target ? 0 : -1);
      if (focusDate && target) target.focus();
    };
    const open = mode => {
      opener = mode === 'arrival' ? startButton : endButton;
      originalRange = [start.value, end.value];
      phase = mode === 'departure' && start.value ? 'departure' : 'arrival';
      month = parse((mode === 'departure' ? end.value || start.value : start.value) || today);
      month.setDate(1);
      render();
      calendar.returnValue = '';
      calendar.showModal();
      grid.querySelector('button[tabindex="0"]')?.focus();
    };
    start.min = today;
    end.min = today;
    form.querySelector('[for="'+start.id+'"]').htmlFor = startButton.id;
    form.querySelector('[for="'+end.id+'"]').htmlFor = endButton.id;
    start.type = 'hidden';
    end.type = 'hidden';
    startButton.hidden = false;
    endButton.hidden = false;
    const weekdayRow = calendar.querySelector('[data-calendar-weekdays]');
    for (let day=5; day<=11; day++) {
      const span = document.createElement('span');
      span.textContent = new Intl.DateTimeFormat(locale,{weekday:'short'}).format(new Date(2026,9,day,12));
      weekdayRow.append(span);
    }
    startButton.addEventListener('click', () => open('arrival'));
    endButton.addEventListener('click', () => open('departure'));
    calendar.querySelector('[data-calendar-close]').addEventListener('click', () => calendar.close('cancel'));
    calendar.addEventListener('close', () => {
      if (calendar.returnValue !== 'selected' && originalRange) {
        [start.value,end.value] = originalRange;
        refreshLabels();
      }
      if (calendar.returnValue !== 'selected') opener?.focus();
    });
    calendar.addEventListener('click', event => { if(event.target === calendar) calendar.close('cancel'); });
    grid.addEventListener('click', event => { const button = event.target.closest('button[data-date]'); if(button && !button.disabled) selectDate(button.dataset.date); });
    const moveMonth = amount => { month = new Date(month.getFullYear(),month.getMonth()+amount,1,12); render(); };
    prev.addEventListener('click', () => moveMonth(-1));
    next.addEventListener('click', () => moveMonth(1));
    grid.addEventListener('keydown', event => {
      const button = event.target.closest('button[data-date]');
      if(!button) return;
      const changes = {ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7};
      if(!(event.key in changes) && !['Home','End','PageUp','PageDown'].includes(event.key)) return;
      event.preventDefault();
      const date = parse(button.dataset.date);
      if(event.key in changes) date.setDate(date.getDate()+changes[event.key]);
      if(event.key === 'Home') date.setDate(date.getDate()-(date.getDay()+6)%7);
      if(event.key === 'End') date.setDate(date.getDate()+6-(date.getDay()+6)%7);
      if(event.key === 'PageUp' || event.key === 'PageDown') {
        const oldDay = date.getDate();
        date.setDate(1);
        date.setMonth(date.getMonth()+(event.key === 'PageUp'?-1:1));
        date.setDate(Math.min(oldDay,new Date(date.getFullYear(),date.getMonth()+1,0).getDate()));
      }
      if(iso(date)<today) return;
      month = new Date(date.getFullYear(),date.getMonth(),1,12);
      render(iso(date));
    });
    refreshLabels();
    form.querySelectorAll('[name="location"]').forEach(input=>input.addEventListener('change',()=>{
      const station = form.querySelector('[name="location"]:checked').value !== 'airport';
      form.action = station ? form.dataset.stationUrl : airportUrl;
      const card = form.closest('.pc-booking');
      card.querySelector('[data-airport-discount]').hidden = station;
      card.querySelector('[data-station-payment]').hidden = !station;
    }));
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const error = form.querySelector('.pc-form-error');
      if(!start.value || !end.value || start.value<today || end.value<start.value) {
        error.hidden = false;
        open(!start.value ? 'arrival' : 'departure');
        return;
      }
      if(!arrivalTime.value || !departureTime.value || (start.value === end.value && departureTime.value<=arrivalTime.value)) {
        error.hidden = false;
        departureTime.focus();
        return;
      }
      error.hidden = true;
      const url = new URL(form.action, window.location.origin);
      url.searchParams.set('arrival_time',arrivalTime.value);
      url.searchParams.set('departure_time',departureTime.value);
      const destination = form.querySelector('[name="location"]:checked').value;
      if(destination !== 'airport') url.searchParams.set('destination',destination);
      url.searchParams.set('payment',event.submitter?.value === 'later' ? 'later' : 'online');
      url.searchParams.set('dates',start.value.replaceAll('-','/')+'-'+end.value.replaceAll('-','/'));
      window.location.assign(url.href);
    });
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
